import {DragDropModule} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSliderModule} from '@angular/material/slider';
import {SharedCurrentSkedModule} from '../current-sked/shared-current-sked.module';
import {OphAutocompleteComponent} from '../design/oph-autocomplete/oph-autocomplete.component';
import {OphAvatarComponent} from '../design/oph-avatar/oph-avatar.component';
import {OphButtonModule} from '../design/oph-button/oph-button.module';
import {OphIconModule} from '../design/oph-icon/oph-icon.module';
import {OphInputsModule} from '../design/oph-inputs/oph-inputs.module';
import {OphNewButtonComponent} from '../design/oph-new-button/oph-new-button.component';
import {OphQuillEditorModule} from '../design/oph-quill-editor/oph-quill-editor.module';
import {OphRadioButtonModule} from '../design/oph-radio-button/oph-radio-button.module';
import {OphXButtonComponent} from '../design/oph-x-button/oph-x-button.component';
import {ListViewsModule} from '../list-views/list-views.module';
import {PipesModule} from '../pipes/pipes.module';
import {TaskBackButtonComponent} from './back-button/task-back-button.component';
import {TaskBottomSheetComponent} from './bottom-sheet/task-bottom-sheet.component';
import {TaskDurationSliderComponent} from './duration-slider/task-duration-slider.component';
import {TaskIconPickerComponent} from './icon-picker/task-icon-picker.component';
import {TaskLocationSelectorComponent} from './location-selector/task-location-selector.component';
import {NewTaskButtonModule} from './new-task-button/new-task-button.module';
import {TaskNumberInputComponent} from './number-input/task-number-input.component';
import {TaskPrioritySelectorComponent} from './priority-selector/task-priority-selector.component';
import {ProvisionsSelectorComponent} from './provisions-selector/provisions-selector.component';
import {TaskRepetitionComponent} from './repetition/task-repetition.component';
import {TaskDialogRequirementItemComponent} from './requirements/item/task-dialog-requirement-item.component';
import {TaskDialogRequirementsComponent} from './requirements/task-dialog-requirements.component';

import {UserHasRoleOptionDirective} from '../directives/user-has-role-option.directive';
import {SubtaskEditComponent} from './subtasks/subtask-edit/subtask-edit.component';
import {SubtaskListComponent} from './subtasks/subtask-list/subtask-list.component';
import {TempIconModalComponent} from './temp-icon-modal/temp-icon-modal.component';

@NgModule({
  imports: [
    CommonModule,
    NewTaskButtonModule,
    OphIconModule,
    MatMenuModule,
    ListViewsModule,
    PipesModule,
    OphInputsModule,
    OphButtonModule,
    MatProgressSpinnerModule,
    DragDropModule,
    MatIconModule,
    ReactiveFormsModule,
    PipesModule,
    MatSliderModule,
    MatDatepickerModule,
    OphRadioButtonModule,

    OphAutocompleteComponent,
    SharedCurrentSkedModule,
    OphXButtonComponent,
    OphNewButtonComponent,
    OphXButtonComponent,
    OphAvatarComponent,
    OphQuillEditorModule,
    OphXButtonComponent,
    OphAvatarComponent,
    TaskDialogRequirementsComponent,
    TaskDialogRequirementItemComponent,
    UserHasRoleOptionDirective,
    TaskIconPickerComponent,
    TaskDurationSliderComponent,
    TaskPrioritySelectorComponent,
    ProvisionsSelectorComponent,
    SubtaskListComponent,
    SubtaskEditComponent,
  ],
  declarations: [
    TaskBackButtonComponent,
    TaskNumberInputComponent,
    TaskRepetitionComponent,
    TaskLocationSelectorComponent,
    TaskBottomSheetComponent,
    TempIconModalComponent,
  ],
  exports: [
    NewTaskButtonModule,
    SubtaskListComponent,
    SubtaskEditComponent,
    TaskDurationSliderComponent,
    TaskNumberInputComponent,
    TaskRepetitionComponent,
    TaskPrioritySelectorComponent,
    TaskLocationSelectorComponent,
    TaskBottomSheetComponent,
    TaskIconPickerComponent,
    ProvisionsSelectorComponent,
    TaskDialogRequirementsComponent,
    TaskDialogRequirementItemComponent,
  ],
})
export class SharedTasksModule {}
